export default __webpack_public_path__ + "img/5373b0c580135459557d4ce84b2e9405.png";